import { render } from "./Bars.vue?vue&type=template&id=f873b394"
import script from "./Bars.vue?vue&type=script&lang=js"
export * from "./Bars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/Bars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f873b394"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f873b394', __exports__)) {
    api.reload('f873b394', __exports__)
  }
  
  module.hot.accept("./Bars.vue?vue&type=template&id=f873b394", () => {
    api.rerender('f873b394', render)
  })

}


export default __exports__